import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingSpinnerProps {
  message?: string;
  minHeight?: number | string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message, minHeight = 200 }) => (
  <Box
    role="status"
    aria-live="polite"
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 2,
      minHeight: minHeight
    }}>
    <CircularProgress />
    {message && (
      <Typography variant="body2" sx={{
        color: "text.secondary"
      }}>
        {message}
      </Typography>
    )}
  </Box>
);

export default LoadingSpinner;
